document.addEventListener('DOMContentLoaded' , () =>{
	//pilotostory-page	
	if(document.querySelector('.pilotostory-page')){
		$('.pilotostory-slide').slick({
			// lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
			variableWidth: true,
			centerMode: true,
			responsive: [
				{
				  breakpoint: 768,
				  settings: {
					variableWidth: true,
					centerMode: false,
				  }
				},
			]			
        });
	}
});